import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './partners-card.scss';

class PartnersCard extends PureComponent {
  render() {
    const { logo, label, site } = this.props;

    return (
      <div className="partners-card">
        <div className="partner-card-logo">
          <img src={logo} alt={label} />
        </div>

        <h3 dangerouslySetInnerHTML={{ __html: label }} />

        <a href={`//${site}/`} target="_blank">{site}</a>
      </div>
    );
  }
}

PartnersCard.propTypes = {
  logo: PropTypes.string,
  label: PropTypes.string,
  site: PropTypes.string
};

export default PartnersCard;



// WEBPACK FOOTER //
// ./src/components/Partners/PartnersCard.js